import MaterialTable from 'material-table';
import React, { useContext } from 'react';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import { CloudDownload } from '@material-ui/icons';
import { IconButton, Tooltip } from '@material-ui/core';
import { LoginContext } from '../../contexts/LoginContext';
import MerchandiseRemittanceAPI from '../../services/MerchandiseRemittanceApi';
import { AppContext } from '../../contexts/AppContext';
import { decodeFile } from '../../utils/MiscellaneousUtils';

const MerchandiseRemittanceGrid = ({ data, tableRef }) => {
  const { isAllowedByRole } = useContext(LoginContext);
  const { showError } = useContext(AppContext);

  const getFile = data => {
    MerchandiseRemittanceAPI.getFile(btoa(data))
      .then(res => decodeFile(res, 'RemitoDeMercaderia.pdf'))
      .catch(error => showError('Error al descargar archivo'));
  };

  const colDefs = useGridColDefs([
    { title: 'Nro. remito', field: 'dispatchCode' },
    { title: 'Nro. Pedido de compra', field: 'purchaseOrderCode' },
    { title: 'Fecha de ingreso del remito', field: 'dispatchStartDate', valueType: 'date' },
    {
      title: 'Descarga de pdf',
      field: 'urlPdfDispatch',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip
          title={value !== '' ? 'Ver adjuntos' : 'No se encontraron adjuntos'}
          enterDelay={tooltipDelay}
          enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={value === ''}
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => isAllowedByRole() && getFile(value)}>
              <CloudDownload />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
  ]);

  return (
    <MaterialTable
      {...defaultGridOptions}
      columns={colDefs}
      data={data}
      tableRef={tableRef}
      options={{
        ...defaultGridOptions.options,
        pageSize: tableRef?.current?.dataManager?.pageSize || defaultGridOptions.options.pageSize,
      }}
    />
  );
};

export default MerchandiseRemittanceGrid;
